<template>
  <div>
    Display MaxxSafe Configuration Here...
  </div>
</template>

<script>
export default {
  name: 'MaxxSafeConfig',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
